import { createFileRoute, redirect } from "@tanstack/react-router"
import { isDeveloper } from "@/hooks/useAuth"

export const Route = createFileRoute("/admin/user-groups")({
  beforeLoad: () => {
    if (isDeveloper()) return

    const apps: string[] = JSON.parse(localStorage.getItem("apps") || "[]")
    if (!apps.includes("user_groups")) {
      throw redirect({ to: "/admin" })
    }
  },
})
